import { daysBetween, todayKey } from "@mmm/shared";
import { Badge, useT } from "@mmm/ui";
export function DueBadge({ startDate }: { startDate: string }) {
  const t = useT();
  const diff = daysBetween(todayKey(), startDate);

  if (diff < 0) return <Badge tone="overdue">{t("calendar.daysOverdue", { count: -diff })}</Badge>;
  if (diff === 0) return <Badge tone="today">{t("common.today")}</Badge>;
  return <Badge tone="upcoming">{t("calendar.daysLeft", { count: diff })}</Badge>;
}
